export class ApexExtensions {
    minimalSpacing = 1;

    constructor(
        private el:Element,
    ) { }

    public FixOverlappingLabels(fromResize: boolean = false) {
        let labels = this.el.querySelectorAll<SVGGraphicsElement>(".apexcharts-xaxis-label");
        let prev = labels[0];
        for (let i = 1; i < labels.length; i++) {
            let el = labels[i];
            if (this.isOverlapping(el, prev)) {
                if (i == labels.length - 1) { //is last
                    prev.style.display = "none";
                } else {
                    el.style.display = "none";
                }
            } else {
                prev = el;
            }
        }

        let svg = this.el.querySelector<SVGGraphicsElement>("svg");
        if (svg != null) {
            svg.style.overflow = "visible";
        }

        if (!fromResize) {
            window.addEventListener("resize", _ => setTimeout(() => this.FixOverlappingLabels(true), 200));
        }
    }

    private isOverlapping(curr: SVGGraphicsElement, prev: SVGGraphicsElement): boolean {
        let w = prev.getBBox().width;
        let h = prev.getBBox().height;
        let rw = prev.getBoundingClientRect().width;
        let rh = prev.getBoundingClientRect().height;

        let sin = (w * rh - h * rw) / (w*w - h*h);
        let angle = Math.asin(sin);
        //let degrees = Math.round(180 * angle / Math.PI);

        let neededSpacing = Math.floor(angle > 0 ? h : w);
        let actualSpacing = Math.ceil(curr.getBBox().x - prev.getBBox().x);
        
        return actualSpacing <= neededSpacing + this.minimalSpacing;
    }
}